//@ flow
const pasteBaseline = (payload) => {
    const {
        pastedData,
        rowIndex,
        columnIndex,
        ucid
    } = payload;
    window.dispatchEvent(
        new CustomEvent('baselinePasted', {
            detail: {
                payload: 'Baseline cell pasted successfully',
                stopLoading: true,
                type: 'success',
                pastedData: pastedData,
                rowIndex: rowIndex,
                columnIndex: columnIndex,
                ucid: ucid
            }
        })
    );
    return;
}

export default pasteBaseline;
